<template>
  <div class="login-page">
    <b-container class="h-100 d-flex justify-content-center align-items-center">
      <b-card class="login-card shadow-lg" no-body>
        <div class="text-center mb-4">
          <img src="logo.png" class="logo-img" alt="The Eagle Logo" />
          <h3 class="title">Welcome to <br>The Eagle</h3>
        </div>
        <b-form @submit.prevent="handleLogin" style='text-align:left;'>
          <b-form-group label="username" label-for="username">
            <b-form-input
              id="username"
              v-model="form.username"
              type="username"
              placeholder="Enter your username"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Password" label-for="password">
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              placeholder="Enter your password"
              required
            ></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary" block class="login-btn">
            Login
          </b-button>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: new window.Form({
        username: '',
        fullname: '',
        phone_number: '',
        email: '',
        country: '',
        city: '',
        address: '',
        attachment: '',
        password_confirmation: '',
        password: '',
      }),
    };
  },
  methods: {
    handleLogin() {
         this.loading = true
         var form =window.VFToF(this.form)
          this.$store.dispatch('login', {form})
            .then(() => {
              this.$router.push('/admin')
              this.loading = false
            })
            .catch(() => {
              window.Toast.fire({
            icon: "error",
            title:'Wrong username or password !!',
          });
            })
    },
  }
};
</script>

<style scoped>
.login-page {
  height: 100vh;
  background: linear-gradient(to right, #0f2027, #203a43, #2c5364);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  max-width: 400px;
  width: 100%;
  padding: 2rem;
  border-radius: 1rem;
  background: white;
  animation: fadeInUp 0.7s ease;
}

.logo-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid gold;
  box-shadow: 0 0 1px gold, 0 0 5px gold, 0 0 10px gold;
 
  margin-bottom: 10px;
}


.title {
  font-weight: bold;
  color: #2c3e50;
}

.subtitle {
  color: #7f8c8d;
  font-size: 0.9rem;
}

.login-btn {
  margin-top: 20px;
  background: #007bff;
  border: none;
  font-weight: bold;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background-color: #0056b3;
}

@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
